import { render, staticRenderFns } from "./home_seckill.vue?vue&type=template&id=13d4659b&scoped=true"
import script from "./home_seckill.vue?vue&type=script&lang=js"
export * from "./home_seckill.vue?vue&type=script&lang=js"
import style0 from "./home_seckill.vue?vue&type=style&index=0&id=13d4659b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4659b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d4659b')) {
      api.createRecord('13d4659b', component.options)
    } else {
      api.reload('13d4659b', component.options)
    }
    module.hot.accept("./home_seckill.vue?vue&type=template&id=13d4659b&scoped=true", function () {
      api.rerender('13d4659b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_seckill.vue"
export default component.exports